import React, { useState } from "react"
import Image from "../components/image"
import VisibilitySensor from "react-visibility-sensor"
import HeroMask from "../components/svg/hero-mask"

/* Notes: 
Videos should placed in the `public > video` folder and referenced like '/video/covid-19/example.mp4'
*/

export default function Hero({
  video,
  image,
  alt,
  title,
  text,
  basic,
  classes,
}) {
  const [loaded, setLoaded] = useState(false)
  const prefersReducedMotion =
    typeof window !== "undefined"
      ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
      : false

  // Only play the animation once based on the 'loaded' state
  const onChange = isVisible => {
    isVisible ? setLoaded(true) : setLoaded(false)
  }
  return (
    <section
      className={`
      hero
      ${video ? "hero--video" : ""}
      ${basic ? "hero--basic" : ""}
      ${!image ? "hero--no-image" : ""}
      ${classes ? classes : ""}
    `}
    >
      <div className="container">
        {title ? (
          <header>
            <h1 className="hero__title">{title}</h1>{" "}
            {text ? <p className="hero__subtitle">{text}</p> : null}
          </header>
        ) : null}
        {video || image ? (
          <VisibilitySensor
            onChange={onChange}
            active={!loaded}
            partialVisibility={true}
            offset={{ bottom: 200 }}
          >
            <div
              className={`hero__media ${
                loaded ? "hero__media--show" : "hero__media--hidden"
              }`}
            >
              <HeroMask />
              {video && prefersReducedMotion && <Image path={image} />}
              {video && !prefersReducedMotion ? (
                <>
                  <video
                    src={video}
                    muted
                    autoPlay
                    loop
                    playsInline
                    controls
                    className="util__desktop-only"
                    controlsList="nofullscreen nodownload"
                  ></video>
                  <Image className="util__mobile-only" path={image} />
                </>
              ) : image ? (
                <Image path={image} alt={alt} />
              ) : null}
            </div>
          </VisibilitySensor>
        ) : null}
      </div>
    </section>
  )
}

export const HeroCaption = ({ children }) => {
  return (
    <div className="hero__caption">
      <div className="hero__caption__inner">{children}</div>
    </div>
  )
}
